import { render, staticRenderFns } from "./UpdateClientStatus.vue?vue&type=template&id=e57bd63e&"
import script from "./UpdateClientStatus.vue?vue&type=script&lang=js&"
export * from "./UpdateClientStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports